/** base64url string helpers. Obfuscation only — never for security. */

export const toBase64Url = (text: string): string => btoa(text)
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=+$/, '');

export const fromBase64Url = (text: string): string => atob(text.replace(/-/g, '+').replace(/_/g, '/'));
